export const SETTINGS_KEYS = {
  SPELL_CHECK_ENABLED: 'giotto_spell_check_enabled',
  ALIGNMENT_LINES_ENABLED: 'giotto_alignment_lines_enabled',
  CANVAS_ALIGNMENT_LINES_ENABLED: 'giotto_canvas_alignment_lines_enabled',
  OBJECT_ALIGNMENT_LINES_ENABLED: 'giotto_object_alignment_lines_enabled',
  SHOW_DISTANCE_MEASUREMENTS: 'giotto_show_distance_measurements',
  SNAPPING_ENABLED: 'giotto_snapping_enabled',
};

export const DEFAULT_SETTINGS = {
  spellCheckEnabled: true,
  alignmentLinesEnabled: true,
  canvasAlignmentLinesEnabled: true,
  objectAlignmentLinesEnabled: true,
  showDistanceMeasurements: false,
  snappingEnabled: true,
};
